export const GET_COURIERS_SHIFTS = Symbol('GET_COURIERS_SHIFTS');
export const GET_COURIERS_SHIFTS_REQUEST = Symbol('GET_COURIERS_SHIFTS_REQUEST');
export const GET_COURIERS_SHIFTS_SUCCESS = Symbol('GET_COURIERS_SHIFTS_SUCCESS');
export const GET_COURIERS_SHIFTS_ERROR = Symbol('GET_COURIERS_SHIFTS_ERROR');